function zopimBussola() {

    zE(function () {
        $zopim(function() {
            $zopim.livechat.setOnUnreadMsgs(function (number) {
                if(number > 0) {
                    zE.activate();
                }

            });
        });
    });

}
function toggleClassDataZend(classZend) {
    $("[data-zend-init]").each(function () {
        if(classZend) {
            $(this).addClass('is-active');
        } else {
            $(this).removeClass('is-active');
        }

    });

}
function dataZendClick() {

    $("[data-zend-init]").click(function () {
        zE('webWidget', 'toggle');
    })
}

function init() {
    if(window.zE) {
        window.zESettings = {
            webWidget: {
                offset: {
                    horizontal: '80px',
                }
            }
        };
        zopimBussola();
        dataZendClick();
    }
}

export default {
    init,
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/zendesk-chat.js